module.exports = __webpack_public_path__ + "media/images/img/tag_company/deroito-e140b6a1a00045da71530ac218f35399.png";